import { JobPositionInfoCard, Loading } from "@cpj-ai/panel-npm-package";
import { TJobPositionData } from "@pages/JobPosition/View";

interface IJobDetailTabContentProps {
  loading: boolean;
  jobPosition: TJobPositionData;
}

const JobDetailTabContent = ({ loading, jobPosition }: IJobDetailTabContentProps) => {
  if (loading) return <Loading />;

  return <JobPositionInfoCard jobPosition={jobPosition} />;
};

export default JobDetailTabContent;
